"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SorisHugAbilityHandler = exports.SorisHugActorAbilityFactory = exports.SorisHugAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Enum_1 = require("../../utils/Enum");
class SorisHugAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SorisHug;
        this.__typeName = "SorisHug";
    }
}
exports.SorisHugAbilityArgs = SorisHugAbilityArgs;
let SorisHugActorAbilityFactory = class SorisHugActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SorisHug", "AllAllies", 2);
    }
};
SorisHugActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SorisHug")
], SorisHugActorAbilityFactory);
exports.SorisHugActorAbilityFactory = SorisHugActorAbilityFactory;
let SorisHugAbilityHandler = class SorisHugAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        sequence.push(new core_2.AnimateCharacterAbilityVfxStepArgs(ability.invokerId, "SorisHug", "casting"));
        sequence = sequence.pushSequence("parallel");
        const allies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies);
        for (const ally of allies) {
            container.applyHealing({
                healerId: ability.invokerId,
                targetId: ally,
                amount: container.getPercentOfBaseHealth(ally, 10),
                attributePercent: 100,
                sequence: sequence.pushSequence("sequential"),
                onApplied: (sequence) => {
                    sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(ally, "feet", "behind"), "BlueMagicCircle"));
                    if (container.hasAttribute(ability.invokerId, "Charm_HighPriestess_1")) {
                        container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                            .forEach(targetId => {
                            const power = container.getBaseAttributeScore(targetId, "Power");
                            const focus = container.getBaseAttributeScore(targetId, "Focus");
                            const attribute = power > focus ? "Power"
                                : "Focus";
                            container.applyBuff({
                                sequence,
                                creatorId: ability.invokerId,
                                targetId,
                                duration: Duration_1.Duration.Turns(4),
                                effect: new core_1.LinkedEffectsEffectArgs([
                                    new core_1.MaxAttributeIncreaseEffectArgs((0, Enum_1.enumValue)(enums_1.AttributeType, attribute), container.getPercentOfBaseAttributeScore(targetId, 10, attribute))
                                ], false)
                            });
                        });
                    }
                }
            });
        }
    }
};
SorisHugAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SorisHug)
], SorisHugAbilityHandler);
exports.SorisHugAbilityHandler = SorisHugAbilityHandler;
